import Headers from '@mjackson/headers';

export const ADMIN_VENDOR_HEADER = 'x-lk-vendorid-for-admin';
export const ADMIN_VENDOR_FACILITY_KEY = 'x-lk-vendorfacilityid-for-admin';

export const getAdminVendorId = () => localStorage.getItem(ADMIN_VENDOR_HEADER);

export const setAdminVendorId = (vendorId?: string | number | null) => {
  if (vendorId === undefined || vendorId === null || vendorId === '') {
    localStorage.removeItem(ADMIN_VENDOR_HEADER);
    return;
  }
  localStorage.setItem(ADMIN_VENDOR_HEADER, String(vendorId));
};

export const getAdminVendorFacilityId = (): number | undefined => {
  const value = localStorage.getItem(ADMIN_VENDOR_FACILITY_KEY);
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export const setAdminVendorFacilityId = (facilityId?: string | number | null) => {
  if (facilityId === undefined || facilityId === null || facilityId === '') {
    localStorage.removeItem(ADMIN_VENDOR_FACILITY_KEY);
    return;
  }
  localStorage.setItem(ADMIN_VENDOR_FACILITY_KEY, String(facilityId));
};

export function applyAdminVendorHeader(headers?: HeadersInit): Headers | undefined {
  if (!headers) return headers;
  const nextHeaders = headers instanceof Headers ? headers : new Headers(headers);
  const adminVendorId = getAdminVendorId();
  const adminVendorFacilityId = getAdminVendorFacilityId();
  if (!adminVendorId || !adminVendorFacilityId) return nextHeaders;

  nextHeaders.set(ADMIN_VENDOR_HEADER, adminVendorId);
  return nextHeaders;
}
